import { faAngleDown, faAngleUp, faMinus, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { updateCart } from '../../actions/Cart';
import { getLocation } from '../../actions/Locations';
import { getPromotions } from '../../actions/Promotions';
import CONSTANTS from '../../constants';
import GoogleHelper from '../../helpers/GoogleHelper';
import OrderTypeHelper from '../../helpers/OrderTypeHelper';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';
import CartService from '../../services/CartService';

class MenuCart extends Component {
  constructor(props) {
    super(props);
    let current_time = new Date();
    this.state = {
      errors: [],
      showErrors: false,
      enableSubmit: false,
      order_type_id: '',
      delivery_phone: '',
      delivery_location: '',
      delivery_address: '',
      car_number: '',
      car_model: '',
      comment: '',
      current_time,
      order_time: current_time,
      order_date: CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY,
      show_time_component: false,
      promoCode: '',
      promoErrorMessage: '',
      manualAppliedPromo: null
    };
  }

  firebaseEvent(eventName, data = {}) {
    AnalyticsService.logEvent(eventName, {
      category: CONSTANTS.EVENTS.CONFIRM_ORDER.GROUP_NAME,
      locationId: this.props._location.slug,
      ...data
    });
  }

  computeDeliveryCharges() {
    let { _location } = this.props;
    if (
      OrderTypeHelper.isDelivery(_location.orderTypes, this.state.order_type_id) &&
      this.state.delivery_location
    ) {
      let orderTotal = CartService.getOrderTotal(_location.loc_id, _location.tax_percent);
      let deliveryArea = GoogleHelper.getDeliveryArea(
        this.state.delivery_location,
        _location.deliveryAreas,
        orderTotal
      );
      if (deliveryArea)
        CartService.setDeliveryCharge(this.props._location.loc_id, deliveryArea.deliveryCharges);
    } else {
      this.clearDeliveryCharges();
    }
  }

  addItemWithOptions(lineItem) {
    if (this.props._location.is_homecheff && lineItem.daily_limit !== null) {
      let lineItems = CartService.getLineItems(this.props._location.loc_id);
      let output = _(lineItems)
        .groupBy('menu_id')
        .map((objs, key) => ({
          'itemCount': _.sumBy(objs, 'itemCount')
        }))
        .value();
      if (output[0].itemCount < lineItem.daily_limit) {
        CartService.addItem(lineItem);
      } else {
        toast.warn('Daily quantity limit exceeded.', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark'
        });
      }
    } else {
      CartService.addItem(lineItem);
    }
    this.computeDeliveryCharges();
    this.props.updateCart();
    this.enableSubmit();
  }

  removeItemWithOptions(lineItem) {
    CartService.removeItemWithOptions(lineItem);
    this.computeDeliveryCharges();
    this.props.updateCart();
    this.enableSubmit();
    if (lineItem.isRewardItem) {
      localStorage.setItem('isRewardOrder', false);
      this.props.toggleCart();
    }
  }
  clearDeliveryCharges() {
    CartService.removeDeliveryCharge(this.props._location.loc_id);
  }
  enableSubmit() {
    let { enableSubmit, showErrors, errors } = OrderTypeHelper.validateOrder(
      this.props._location,
      this.state
    );
    return this.setState({ enableSubmit, showErrors, errors, showAllErrors: false });
  }
  renderCart(locationId) {
    let lineItems = CartService.getLineItems(locationId);
    const _location = this.props._location;
    return lineItems.map((lineItem) => {
      if (this.props.grid_layout === 'old') {
        return (
          <div className="line-item-container-custom p-3 branding-border-bottom" key={lineItem.identifier}>
            <div className="line-item">
              <div className="f2 quantity highlight-color">{lineItem.itemCount}x </div>
              <div className="f2 name card-font-color">
                {lineItem.menu_name}
                <div className="text-muted f3 pt-2">
                  {lineItem.portionSize && lineItem.portionSize.label}
                </div>
                {this.renderOptions(lineItem.groupedOptions, 'name')}
              </div>
              <div className="price text-right text-bold card-font-color">
                {ViewHelper.toCurrency(
                  lineItem.itemTotal,
                  _location.currency,
                  _location.decimal_places
                )}
              </div>
            </div>
            {lineItem.comment && (
              <div className="line-item">
                <div className="quantity" />
                <div className="name f3 font-italic card-subtitle-color">{lineItem.comment}</div>
                <div className="price text-right text-bold card-font-color" />
              </div>
            )}
            <div className="actions text-right pt-2">
              <FontAwesomeIcon
                className="cursor remove p-1"
                icon={faAngleDown}
                onClick={this.removeItemWithOptions.bind(this, lineItem)}
              />
              <FontAwesomeIcon
                className="cursor add p-1"
                icon={faAngleUp}
                onClick={this.addItemWithOptions.bind(this, lineItem)}
              />
            </div>
          </div>
        );
      } else if (this.props.grid_layout !== 'old') {
        return (
          <div className="line-item-container-custom  p-3" key={lineItem.identifier}>

            <div className="line-item">
              <div className="line-item-quantity-section ">
                <div className="f2 quantity highlight-color-active">{lineItem.itemCount}x </div>
              </div>
              <div className="line-item-container-item-custom">
                <div className="f2 name">
                  <div className="name-data card-font-color">{lineItem.menu_name}</div>
                  <div className="price text-right text-bold">
                    <div className="price_data card-font-color" >
                      {lineItem.isRewardItem ?

                        <a className='reward-text-bg-red highlight-color-active'>Reward</a>
                        :
                        ViewHelper.toCurrency(
                          lineItem.itemTotal,
                          _location.currency,
                          _location.decimal_places
                        )

                      }
                    </div>
                  </div>
                </div>
                <div className="options-data">
                  <div className="options-data__left-side">
                    <div className="f3 pt-2 card-subtitle-color">
                      {lineItem.portionSize && lineItem.portionSize.label}
                    </div>
                    {this.renderOptions(lineItem.groupedOptions, 'name')}
                    {lineItem.comment && (
                      <div className="f3 pt-2 card-subtitle-color">{lineItem.comment}</div>
                    )}
                  </div>
                  {
                    !lineItem.isRewardItem ?
                      <div className="options-data__right-side">
                        <div className="actions text-right pt-2">
                          <div
                            className="remove"
                            onClick={this.removeItemWithOptions.bind(this, lineItem)}
                          >
                            {/*<img src={removeIcon} alt=""/>*/}
                            <FontAwesomeIcon
                              icon={faMinus}
                              style={{ padding: 2, fontSize: '1.0rem' }}
                            />
                            {/*<FontAwesomeIcon className='cursor remove' icon={faMinus} onClick={this.removeItemWithOptions.bind(this, lineItem)} />*/}
                          </div>
                          <div className="add" onClick={this.addItemWithOptions.bind(this, lineItem)}>
                            {/*<img src={addIcon} alt=""/>*/}
                            <FontAwesomeIcon icon={faPlus} style={{ padding: 2, fontSize: '1.0rem' }} />
                          </div>
                        </div>
                      </div> :
                      <div className="options-data__right-side options-data__right-side-reward">
                        <div className="actions actions-reward pt-2">
                          <div
                            className="remove"
                            onClick={this.removeItemWithOptions.bind(this, lineItem)}
                          >
                            {/*<img src={removeIcon} alt=""/>*/}
                            <FontAwesomeIcon
                              icon={faTrash}
                              style={{ padding: 2, fontSize: '1.0rem' }}
                            />
                            {/*<FontAwesomeIcon className='cursor remove' icon={faMinus} onClick={this.removeItemWithOptions.bind(this, lineItem)} />*/}
                          </div>

                        </div>
                      </div>
                  }
                </div>
              </div>
            </div>
            {/*<div className='actions text-right pt-2'>*/}
            {/*  <FontAwesomeIcon className='cursor remove' icon={faAngleDown} onClick={this.removeItemWithOptions.bind(this, lineItem)} />*/}
            {/*  <FontAwesomeIcon className='cursor add' icon={faAngleUp} onClick={this.addItemWithOptions.bind(this, lineItem)} />*/}
            {/*</div>*/}
          </div >
        );
      }
      return '';
    });
  }
  renderOptions(options, key) {
    if (options && options.length > 0) {
      return options.map((option) => {
        if (key === 'name')
          return (
            <div key={option.option_value_id + key} className="f3 pt-2 card-subtitle-color">
              {`${option.optionCount}x`} {option.option_value_name}
            </div>
          );
        if (key === 'price')
          return (
            <div key={option.option_value_id + key} className="f3 pt-2 card-subtitle-color">
              {ViewHelper.toCurrency(
                option.price,
                this.props._location.currency,
                this.props._location.decimal_places
              )}
            </div>
          );
        return '';
      });
    }
    return '';
  }
  render() {
    const _location = this.props._location;
    return <React.Fragment>{this.renderCart(_location.loc_id)}</React.Fragment>;
  }
}
function mapStateToProps(state) {
  const { location, cart, promotions, error, locationSettings } = state;
  const promotionTitles =
    promotions && location ? ViewHelper.getPromotionTitles(promotions, location) : [];
  return { cart, promotions, promotionTitles, error, locationSettings };
}

export default connect(mapStateToProps, { getLocation, updateCart, getPromotions })(MenuCart);
